import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';
import moment from 'moment';
import { Button, DatePicker, Input, message, Row } from 'antd';
import { SearchOutlined, DownloadOutlined, CaretRightOutlined } from '@ant-design/icons';
import { runScheduleDowngradeFreeWhenExpired } from 'apis/user';
import { useUserHistory } from 'hooks/use-user-history';

const { RangePicker } = DatePicker;

export default function SearchToolbar({
  type, // 'date' | 'email'
  fromDate,
  toDate,
  email,
  onChange,
  onSearch,
  disabled,
  togglePause,
}) {
  const { total, totalUsers, isPaused, initialLoading } = useUserHistory();
  const exportExcel = () => {
    const usersHistoryRef = useUserHistory.getState().usersHistoryRef;
    const templateData = usersHistoryRef.map(item => ({
      'Created At': item?.createdAt,
      'ID': item?.userId,
      'Email': item?.email,
      'Role': item?.role?.toUpperCase(),
      'VIP': item?.isVip ? 'X' : ''
    }));

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = { Sheets: { Data: ws }, SheetNames: ['Data'] };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    const fileName = `users_${moment().format("MMMM_Do_YYYY_h_mm").trim()}`;
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        {type === 'date' ? (
          <RangePicker
            ranges={{
              'Today': [moment(), moment()],
              'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
              'This Week': [moment().startOf('week'), moment().endOf('week')],
              'This Month': [moment().startOf('month'), moment().endOf('month')],
              'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
              'This Year': [moment().startOf('year'), moment().endOf('year')],
            }}
            onChange={onChange}
            value={[fromDate, toDate]}
            allowClear={false}
            className='w-[288px]'
            disabled={disabled}
          />
        ) : (
          <Input
            placeholder="Email"
            value={email}
            onChange={(e) => onChange(e.target.value)}
            className='w-[288px]'
            disabled={disabled}
          />
        )}

        <Button
          type="primary"
          icon={<SearchOutlined />}
          disabled={disabled}
          onClick={() => {
            if (type === 'email' && !email) {
              message.error('Email is required');
              return;
            }
            onSearch();
          }}
        >
          Search
        </Button>

        {!initialLoading && totalUsers < total && (
          <Row className="inline-flex items-center gap-4">
            <Button onClick={togglePause}>
              {isPaused ? "Resume" : "Pause"}
            </Button>
            <span>Loaded <span style={{ fontWeight: 600 }}>{totalUsers} / {total}</span> users</span>
          </Row>
        )}
      </div>

      <div className="flex items-center gap-4">
        <Button
          type="link"
          icon={<DownloadOutlined />}
          onClick={exportExcel}
          className="flex items-center justify-center"
        >
          Download
        </Button>

        <Button
          type="link"
          icon={<CaretRightOutlined />}
          onClick={() => {
            runScheduleDowngradeFreeWhenExpired()
              .then(() => message.success('Done'))
              .catch(() => message.error('Error'))
          }}
          className="flex items-center justify-center"
        >
          Downgrade Schedule (Manually)
        </Button>
      </div>
    </div>
  );
};
